import React from 'react';

export function Stepper({ steps = [], activeStep = 0, className = '' }) {
  return (
    <ol className={`ds-stepper ${className}`.trim()}>
      {steps.map((label, index) => (
        <li
          key={label}
          className={[
            'ds-stepper__step',
            index < activeStep ? 'ds-stepper__step--done' : '',
            index === activeStep ? 'ds-stepper__step--active' : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          <span className="ds-stepper__num">{index + 1}</span>
          <span className="ds-stepper__label">{label}</span>
        </li>
      ))}
    </ol>
  );
}

export default Stepper;
